import { ChangeEvent } from 'react'
import styles from './DefaultTextInput.module.css'

interface DefaultTextInputProps {
  value: string
  onChange: (value: string) => void
  maxLength?: number
  placeholder?: string
  disabled?: boolean
  label?: string
  width?: number
}

export const DefaultTextInput = ({
  value,
  onChange,
  maxLength,
  placeholder,
  disabled,
  label,
  width = 200,
}: DefaultTextInputProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  return (
    <>
      {label && <label className={styles.inputLabel}>{label}</label>}
      <input
        className={styles.defaultTextInput}
        type="text"
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        style={{ width: width }}
      />
    </>
  )
}
